export const primaryActionText = 'Okay, understood';
export const secondaryActionText = 'Add another car';
export const modalTitleLine1 = 'Oops! We don’t service EVs yet.';
export const modalTitleLine2 = 'Stay tuned, we’re working on it';
